export default {
      id: "deco_actu-usage",
      viewBox: "0 0 130 125",
      url: "../dist/images/" + "sprite.svg#deco_actu-usage",
      toString: function () {
        return this.url;
      }
    }